import React, { useEffect, useState } from "react";
import "./Header.css";
import logo from "../../../assets/img/logo4.png";
import mobileLogo from "../../../assets/img/vibelogo.png";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/userSlice";
import PersonIcon from "@mui/icons-material/Person";

export default function Header({ scrollToSection, activeSection }) {
  const user = useSelector(selectUser);

  let lastScrollPosition = window.scrollY;
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMobileMenu, setIsMobileMenu] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 972) {
      setIsMobileView(true);
      setIsMobileMenu(false);
    } else {
      setIsMobileView(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 972) {
        setIsMobileView(true);
        setIsMobileMenu(false);
      } else {
        setIsMobileView(false);
      }
    });
  }, []);

  window.addEventListener("scroll", () => {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition > lastScrollPosition) {
      // Scrolling down
      setIsNavbarVisible(false);
    } else if (currentScrollPosition < lastScrollPosition) {
      // Scrolling up
      setIsNavbarVisible(true);
    }

    // Update the last scroll position for the next comparison
    lastScrollPosition = currentScrollPosition;
  });
  return (
    <header className={`header ${!isNavbarVisible && "not-visible"}`}>
      <Link to={"/"} className="logo">
        <img
          src={isMobileView ? mobileLogo : logo}
          className={`logo-img ${isMobileView && "mobile"}`}
          alt="vibes&vent logo"
        />
      </Link>

      {isMobileView ? (
        <MenuIcon
          onClick={() => setIsMobileMenu((current) => (current = !current))}
        />
      ) : (
        <>
          <nav className="nav">
            <div
              className={
                activeSection === "hero" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("hero")}
            >
              Home
            </div>
            <div
              className={
                activeSection === "about" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("about")}
            >
              About
            </div>
            <div
              className={
                activeSection === "why-us" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("why-us")}
            >
              {" "}
              Why us
            </div>
            <div
              className={
                activeSection === "how-it-works"
                  ? "nav-option active"
                  : "nav-option"
              }
              onClick={() => scrollToSection("how-it-works")}
            >
              How it works
            </div>
            <div
              className={
                activeSection === "faq" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("faq")}
            >
              FAQs
            </div>
          </nav>
          {/* {console.log(user?.photoURL)} */}
          <Link to={"/therapists"} className="user-details">
            {user?.photoURL ? (
              <img
                src={user?.photoURL}
                className={`${user?.photoURL && "icon"}`}
                alt={`${user?.photoURL}`}
              />
            ) : user ? (
              <div className="icon">
                <PersonIcon />
              </div>
            ) : (
              <Link to={"/therapists"} className="find-a-therapist">
                Find a therapist
              </Link>
            )}
            <p>{user?.displayName}</p>
          </Link>
        </>
      )}
      {isMobileMenu && isMobileView && (
        <nav className="nav mobile">
          <div className="nav-option" onClick={() => scrollToSection("hero")}>
            Home
          </div>
          <div className="nav-option" onClick={() => scrollToSection("about")}>
            About
          </div>
          <div className="nav-option" onClick={() => scrollToSection("why-us")}>
            Why us
          </div>
          <div
            className="nav-option"
            onClick={() => scrollToSection("how-it-works")}
          >
            How it works
          </div>
          <div className="nav-option" onClick={() => scrollToSection("faq")}>
            FAQs
          </div>
        </nav>
      )}
    </header>
  );
}
